import * as ThirdPartyToHostEvents from '../types/ThirdPartyToHostEvents';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
export const handleBroadcastSdkEvents = (message, updateWidgetDetails) => {
  const {
    type,
    payload
  } = message;
  if (type === ThirdPartyToHostEvents.INITIALIZED) {
    updateWidgetDetails(Object.assign({
      callStatus: CallWidgetStates.READY,
      isLoggedIn: payload.isLoggedIn || false,
      userAvailable: payload.isAvailable || false
    }, payload.sizeInfo && {
      sizeInfo: payload.sizeInfo
    }));
  }
  if (type === ThirdPartyToHostEvents.LOGGED_IN) {
    updateWidgetDetails({
      isLoggedIn: true
    });
  }
  if (type === ThirdPartyToHostEvents.LOGGED_OUT) {
    updateWidgetDetails({
      isLoggedIn: false
    });
  }
  if (type === ThirdPartyToHostEvents.USER_AVAILABLE) {
    updateWidgetDetails({
      userAvailable: true
    });
  }
  if (type === ThirdPartyToHostEvents.USER_UNAVAILABLE) {
    updateWidgetDetails({
      userAvailable: false
    });
  }
  if (type === ThirdPartyToHostEvents.OUTGOING_CALL_STARTED) {
    updateWidgetDetails({
      callStatus: CallWidgetStates.INITIALIZING_OUTBOUND_CALL
    });
  }
  if (type === ThirdPartyToHostEvents.INCOMING_CALL) {
    updateWidgetDetails({
      callStatus: CallWidgetStates.INCOMING_INBOUND_CALL
    });
  }
  if (type === ThirdPartyToHostEvents.CALL_ANSWERED) {
    updateWidgetDetails({
      callStatus: CallWidgetStates.ANSWERED
    });
  }
  if (type === ThirdPartyToHostEvents.CALL_ENDED) {
    updateWidgetDetails({
      callStatus: CallWidgetStates.ENDED
    });
  }
  if (type === ThirdPartyToHostEvents.CALL_COMPLETED) {
    updateWidgetDetails({
      callStatus: CallWidgetStates.READY
    });
  }
};